import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga4';
// Google Analytics Measurement ID
const TRACKING_ID = 'G-JB16CBBQZS';
// Initialize Google Analytics
ReactGA.initialize(TRACKING_ID);
export const GoogleAnalytics = () => {
  const location = useLocation();
  useEffect(() => {
    // Track page views whenever the route changes
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname + location.search
    });
  }, [location]);
  return null;
};